import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { first } from "rxjs";
import { ConfigService } from "src/app/services";

@Component({
  selector: 'app-sla-agreement',
  templateUrl: './sla.agreement.component.html'
})
export class SlaAgreementComponent {

  @Input() submitted = false;
  @Input() form!: FormGroup;

  bestPracticesContent?: string;
  bestPracticesDate?: string;
  public ready = false;
  public licenseAgreementUpdated?: string;
  public licenseAgreementcontent?:string;
  constructor(configService: ConfigService) {
    configService.getConfig().pipe(first()).subscribe(config => {
      this.licenseAgreementUpdated = config.licenseAgreement.updated;
      this.licenseAgreementcontent=config.licenseAgreement.content;
      this.bestPracticesContent = config.bestPractices.content;
      this.bestPracticesDate = config.bestPractices.updated;
      this.ready = true;
    });
  }

}